// import LightsFragment from "./lights_fragment.glsl";
import CustomLightVertex from "./custom_light_vertex.glsl";
import CustomLightFragment from "./custom_light_fragment.glsl";

/* Optimizes lighting by moving area light calculations from the fragment to the vertex shader. */

export default shader => {
  shader.vertexShader = CustomLightVertex;
  shader.fragmentShader = CustomLightFragment;
  /*
  shader.fragmentShader = shader.fragmentShader.replace(
    "#include <lights_fragment_begin>",
    LightsFragment
  );
  */
};
